"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonCta = require("@mmc/common-cta");

var _tableCompare = _interopRequireDefault(require("../../styles/table-compare.css"));

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
    appendImageTransforms = dataUtils.appendImageTransforms;

var getVehicleNameFromSelectedVehicle = function getVehicleNameFromSelectedVehicle(selectedVehicleCode, selectedYear, allVehicles) {
  return allVehicles.find(function (vehicle) {
    return selectedVehicleCode === vehicle.code && selectedYear === parseInt(vehicle.year, 10);
  });
};

var ComparisonBanner = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(ComparisonBanner, _React$PureComponent);

  function ComparisonBanner() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = ComparisonBanner.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        theme = _this$props.theme,
        steps = _this$props.steps,
        vehicles = _this$props.vehicles,
        selectedVehicle = _this$props.selectedVehicle,
        selectedYear = _this$props.selectedYear,
        switchView = _this$props.switchView;
    var selectedVehicleObj = getVehicleNameFromSelectedVehicle(selectedVehicle, selectedYear, vehicles);
    var imageWidth = 640;

    if (selectedVehicleObj) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _tableCompare["default"].comparisonBanner
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _tableCompare["default"].image
      }, /*#__PURE__*/_react["default"].createElement("img", {
        className: theme.marginBottom20 + " " + _tableCompare["default"].vehiclePic,
        src: appendImageTransforms(handleNestedProp(selectedVehicleObj, 'selectedVehicleObj.vehicleImage.image'), imageWidth),
        alt: handleNestedProp(selectedVehicleObj, 'selectedVehicleObj.vehicleImage.altText')
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _tableCompare["default"].headline
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "theme.headingThree"
      }, selectedVehicleObj.name)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _tableCompare["default"].link
      }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        data: {
          priority: 'low',
          label: steps[0].name
        },
        theme: theme,
        clickEvent: switchView
      })));
    }

    return null;
  };

  return ComparisonBanner;
}(_react["default"].PureComponent);

var _default = ComparisonBanner;
exports["default"] = _default;